/** An explicit tenant choice must never fall through to another organization. */
export function resolveRegulationOrg<T extends { readonly id: string; readonly lastChosen: boolean }>(
  activeOrgId: string | null,
  orgs: ReadonlyArray<T>,
  isPending: boolean,
  explicitChoice = true,
): { org: T | null; isLoading: boolean } {
  const selected = orgs.find((candidate) => candidate.id === activeOrgId) ?? null;
  const org = selected ?? (activeOrgId !== null && explicitChoice
    ? null
    : orgs.find((candidate) => candidate.lastChosen) ?? null);
  return { org, isLoading: org === null && isPending };
}
